import { IconModule } from './../icon/icon.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DropdownComponent } from "./dropdown.component";
import { TransitionModule } from "../transition/transition.module";
import { CardModule } from "../card/card.module";
import { SelectModule } from "../select/select.module";
import { FormsModule } from "@angular/forms";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";

@NgModule({
	declarations: [DropdownComponent],
	imports: [
		CommonModule,
		CardModule,
		SelectModule,
		LabelModule,
		HelpTextModule,
		StatusModule,
		FormsModule,
		IconModule
	],
	exports: [DropdownComponent]
})
export class DropdownModule {}
